import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	fetchError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fetchError: {
		id: 'jql-builder-basic-cascading-select.services.use-cascading-select-values-loader.fetch-error',
		defaultMessage: 'Something went wrong, please refresh and try again.',
		description: 'Error message for when the cascading select options could not be fetched',
	},
});
export default messages;
